import { PageContainer } from "../components/pageContainer/PageContainer"
import { PrivacyPol } from "../layout/privacyPolicy/PrivacyPol"

export const PrivacyPolicy = () => {
    return (
        <PageContainer>
            <PrivacyPol />
        </PageContainer>
    )
}